// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.requests-table table {
  border-collapse: separate;
  border-spacing: 0px;
  width: 100%;
}
.requests-table table caption {
  caption-side: top;
  text-align: center;
}
.requests-table table thead > tr > th {
  border-radius: 5px 5px 0 0;
  background-color: #C0DEF0;
  border-color: #A7A9AC;
  border-style: solid;
  border-width: 1px;
  color: #0A4064;
  font-size: 0.85rem;
  font-weight: 500;
  padding: 5px;
  text-align: center;
}
.requests-table table thead > tr > th.icon-header {
  font-size: 1.65rem;
}
.requests-table table thead > tr > th.subheader {
  border-radius: revert;
  border: none;
  font-size: 0.75rem;
}
.requests-table table thead > tr > th.left {
  border-left: 1px solid #A7A9AC;
}
.requests-table table thead > tr > th.right {
  border-right: 1px solid #A7A9AC;
}
.requests-table table tbody > tr {
  border-left: 1px solid #A7A9AC;
  border-right: 1px solid #A7A9AC;
}
.requests-table table tbody > tr.stripe {
  background-color: #EDf0F1;
}
.requests-table table tbody > tr.out-of-district {
  background-color: #FDF9D0;
}
.requests-table table tbody > tr.hidden-row {
  display: none;
}
.requests-table table tbody > tr > td {
  border-right: 1px solid #D1D3D4;
  border-bottom: 1px solid #D1D3D4;
  font-size: 0.78rem;
  padding: 3px;
}
.requests-table table tbody > tr > td > button {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.requests-table table tbody > tr > td > button span {
  font-size: 0.9rem;
  font-weight: 500;
}
.requests-table table tbody > tr > td.email {
  max-width: 10%;
  width: 180px;
  word-wrap: anywhere;
}
.requests-table table tbody > tr > td.icons {
  align-items: right;
  background-color: white;
  border: none;
  border-bottom: 1px solid #D1D3D4;
  border-left: 1px solid #D1D3D4;
}
.requests-table table tbody > tr > td.icons-with-note {
  align-items: right;
  background-color: white;
  border: none;
  border-bottom: none;
  border-left: 1px solid #D1D3D4;
}
.requests-table table tbody > tr > td.oe-out {
  background-color: white;
}
.requests-table table td.center {
  text-align: center;
}
.requests-table table tbody > tr > td > div > textarea {
  border-radius: 5px;
  width: 100%;
}
.requests-table table tbody > tr > td > div > button {
  margin-top: 5px;
}
.requests-table table tbody > tr > td.first {
  border-left: 1px solid #A7A9AC;
}
.requests-table table tbody > tr > td.last {
  border-right: 1px solid #A7A9AC;
}
.requests-table table tbody > tr > td.notes {
  background: #C0DEF0;
  font-size: 0.9rem;
  padding: 10px;
}
.requests-table table tbody > tr > td.icon-last {
  border: none;
  border-left: 1px solid #D1D3D4;
  border-bottom: 2px solid #A7A9AC;
}
.requests-table table tbody > tr > td > div.flexed-td {
  align-items: center;
  display: flex;
  font-size: 0.7rem;
  justify-content: flex-start;
}
.requests-table table tbody > tr > td > div.preferred-language {
  border-radius: 3px;
  background-color: #FEBF31;
  color: black;
  font-weight: 420;
  padding: 0 3px 0 3px;
}
.requests-table table tfoot > tr {
  background-color: white;
}
.requests-table table tfoot > tr > td {
  border-top: 1px solid #A7A9AC;
  padding-top: 10px;
}
.requests-table table tfoot > tr > td.icons {
  border-top: 1px solid #A7A9AC;
  padding-top: 10px;
}
.requests-table table tfoot > tr > td > div {
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  margin: 0 auto;
}
.requests-table table tfoot > tr > td > div > .showing-records {
  font-size: 0.8rem;
  font-style: italic;
  margin-top: 5px;
  width: 33%;
}
.requests-table table .small {
  font-size: 0.7rem;
  font-weight: 500;
  margin-left: 5px;
  margin-right: 5px;
}
.requests-table table .fixed-btn {
  display: block;
  margin: 2px 0 2px 0;
  min-width: 120px;
  white-space: nowrap;
}

table#legend-table {
  border-collapse: separate;
  border-spacing: 0px;
  width: 100%;
  margin: 10px 0 10px 0;
  width: 100%;
}
table#legend-table thead > tr > th {
  border-radius: 5px 5px 0 0;
  border: 1px solid #D1D3D4;
  color: #0A4064;
  font-size: 1.65rem;
  font-weight: 500;
  padding: 10px;
}
table#legend-table tbody > tr > td {
  border-right: 1px solid #D1D3D4;
  border-top: 1px solid #D1D3D4;
  padding: 5px;
}
table#legend-table tbody > tr > td.first {
  border-left: 1px solid #D1D3D4;
  text-align: center;
  margin: 0 auto;
  vertical-align: top;
}
table#legend-table tbody > tr > td.first span.sibling-icon {
  font-size: 1.4rem;
}
table#legend-table tbody > tr > td.last {
  border-bottom: 1px solid #D1D3D4;
}
table#legend-table tbody > tr > td.highlight {
  font-size: 0.7rem;
  vertical-align: middle;
}
table#legend-table tbody > tr.out-of-district {
  background-color: #FDF9D0;
}

table#enroll-table tbody > tr > td {
  font-size: 0.9rem;
}

.enroll-p {
  font-size: 0.9rem;
}

.danger-p {
  border-radius: 5px;
  background-color: #FDF9D0;
  border: 2px solid #CB321A;
  color: black;
  padding: 5px;
}

.success-p {
  color: green;
  font-weight: 500;
}

p.out-of-district {
  background-color: #FDF9D0;
}

.iep {
  border-radius: 5px;
  background-color: #0669B3;
  border: 1px solid #0669B3;
  color: #EDEDED;
  font-size: 0.7rem;
  font-weight: bold;
  padding: 4px;
}

.sibling {
  font-size: 1rem;
  padding: 4px;
}

form#request-form div.enroll-flex,
form#enroll-form div.enroll-flex {
  margin-top: 5px;
  width: 100%;
}
form#request-form div.input-row,
form#enroll-form div.input-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 3px;
}
form#request-form input,
form#request-form label,
form#request-form select,
form#request-form textarea,
form#enroll-form input,
form#enroll-form label,
form#enroll-form select,
form#enroll-form textarea {
  border-radius: 3px;
  display: block;
  width: 50% !important;
}
form#request-form input,
form#request-form select,
form#enroll-form input,
form#enroll-form select {
  border-radius: 5px;
  border: none;
  border: 1px solid #808080;
  padding: 5px;
  min-width: 180px !important;
}
form#request-form label,
form#enroll-form label {
  color: #333;
  font-size: 0.9rem;
  font-weight: 500;
}
form#request-form textarea,
form#enroll-form textarea {
  border-radius: 5px;
  border: none;
  border: 1px solid #808080;
  padding: 5px;
  width: 100% !important;
}
form#request-form .checkbox input:before,
form#enroll-form .checkbox input:before {
  content: "";
  background: #fff;
  display: block;
  width: 10px;
  height: 10px;
  border: 1px solid black;
}
form#request-form .checkbox input:checked:before,
form#enroll-form .checkbox input:checked:before {
  background-color: green;
}

div.REQUEST {
  background-color: grey;
  height: 30px;
  margin-right: 5px;
  width: 10px;
}

div.CANCELLED_REQUEST,
div.DENY_OFFER,
div.DENY_REQUEST {
  background-color: red;
  height: 30px;
  margin-right: 5px;
  width: 10px;
}

div.MAKE_OFFER_PENDING,
div.WAIT_LIST {
  background-color: orange;
  height: 30px;
  margin-right: 5px;
  width: 10px;
}

div.MAKE_OFFER {
  background-color: blue;
  height: 30px;
  margin-right: 5px;
  width: 10px;
}

div.ACCEPT_OFFER {
  background-color: #28bfcd;
  height: 30px;
  margin-right: 5px;
  width: 10px;
}

div.ENROLLED {
  background-color: green;
  height: 30px;
  margin-right: 5px;
  width: 10px;
}

div.NO_RESPONSE {
  background-color: purple;
  height: 30px;
  margin-right: 5px;
  width: 10px;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/Requests.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AANI;EACI,yBAAA;EACA,mBAAA;EACA,WAAA;AASR;AAPQ;EACI,iBAAA;EACA,kBAAA;AASZ;AANQ;ECXJ,0BDY8B;EACtB,yBDUA;ECTA,qBDGJ;ECFI,mBAAA;EACA,iBAAA;EACA,cDLF;ECME,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;AAQZ;AALQ;EACI,kBAAA;AAOZ;AAJQ;EACI,qBAAA;EACA,YAAA;EACA,kBAAA;AAMZ;AAHQ;EACI,8BAAA;AAKZ;AAFQ;EACI,+BAAA;AAIZ;AADQ;EACI,8BAAA;EACA,+BAAA;AAGZ;AAAQ;EACI,yBDjCJ;ACmCR;AAEQ;EACI,yBDvCA;ACuCZ;AAGQ;EACI,aAAA;AADZ;AAIQ;EACI,+BAAA;EACA,gCAAA;EACA,kBAAA;EACA,YAAA;AAFZ;AAKQ;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;AAHZ;AAKY;EACI,iBAAA;EACA,gBAAA;AAHhB;AAOQ;EACI,cAAA;EACA,YAAA;EACA,mBAAA;AALZ;AAQQ;EACI,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,gCAAA;EACA,8BAAA;AANZ;AASQ;EACI,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,8BAAA;AAPZ;AAUQ;EACI,uBAAA;AARZ;AAWQ;EACI,kBAAA;AATZ;AAYQ;EC5GJ,kBD6G8B;EACtB,WAAA;AAVZ;AAaQ;EACI,eAAA;AAXZ;AAcQ;EACI,8BAAA;AAZZ;AAeQ;EACI,+BAAA;AAbZ;AAgBQ;EACI,mBDvGA;ECwGA,iBAAA;EACA,aAAA;AAdZ;AAiBQ;EACI,YAAA;EACA,8BAAA;EACA,gCAAA;AAfZ;AAkBQ;EACI,mBAAA;EACA,aAAA;EACA,iBAAA;EACA,2BAAA;AAhBZ;AAmBQ;EChJJ,kBDiJ8B;EACtB,yBDrIA;ECsIA,YAAA;EACA,gBAAA;EACA,oBAAA;AAjBZ;AAoBQ;EACI,uBAAA;AAlBZ;AAqBQ;EACI,6BAAA;EACA,iBAAA;AAnBZ;AAsBQ;EACI,6BAAA;EACA,iBAAA;AApBZ;AAuBQ;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,cAAA;AArBZ;AAwBQ;EACI,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;AAtBZ;AAyBQ;EACI,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;AAvBZ;AA0BQ;EACI,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AAxBZ;;AA6BA;EACI,yBAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;EACA,WAAA;AA1BJ;AA4BI;EC5MA,0BD6M0B;EACtB,yBAAA;EACA,cDnME;ECoMF,kBAAA;EACA,gBAAA;EACA,aAAA;AA1BR;AA6BI;EACI,+BAAA;EACA,6BAAA;EACA,YAAA;AA3BR;AA8BI;EACI,8BAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;AA5BR;AA8BQ;EACI,iBAAA;AA5BZ;AAgCI;EACI,gCAAA;AA9BR;AAiCI;EACI,iBAAA;EACA,sBAAA;AA/BR;AAkCI;EACI,yBDlOI;ACkMZ;;AAqCI;EACI,iBAAA;AAlCR;;AAsCA;EACI,iBAAA;AAnCJ;;AAsCA;EC9PI,kBD+PsB;EACtB,yBDlPQ;ECmPR,yBAAA;EACA,YAAA;EACA,YAAA;AAnCJ;;AAsCA;EACI,YAAA;EACA,gBAAA;AAnCJ;;AAsCA;EACI,yBD9PQ;AC2NZ;;AAsCA;EC/QI,kBDgRsB;EACtB,yBDxPS;ECyPT,yBAAA;EACA,cD7QI;EC8QJ,iBAAA;EACA,iBAAA;EACA,YAAA;AAnCJ;;AAsCA;EACI,eAAA;EACA,YAAA;AAnCJ;;AAwCI;;EACI,eAAA;EACA,WAAA;AApCR;AAuCI;;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AApCR;AAuCI;;;;;;;;EC5SA,kBDgT0B;EACtB,cAAA;EACA,qBAAA;AAjCR;AAoCI;;;;ECrTA,kBAgCsB;EACtB,YAAA;EACA,yBAAA;EACA,YAAA;EDqRI,2BAAA;AA7BR;AAgCI;;EACI,WDtSA;ECuSA,iBAAA;EACA,gBAAA;AA7BR;AAgCI;;ECjUA,kBAgCsB;EACtB,YAAA;EACA,yBAAA;EACA,YAAA;EDgSI,sBAAA;AA1BR;AA6BI;;EACI,WAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;AA1BR;AA6BI;;EACI,uBAAA;AA1BR;;AA8BA;EACI,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;AA3BJ;;AA8BA;;;EAGI,qBAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;AA3BJ;;AA8BA;;EAEI,wBAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;AA3BJ;;AA8BA;EACI,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;AA3BJ;;AA8BA;EACI,yBAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;AA3BJ;;AA8BA;EACI,uBAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;AA3BJ;;AA8BA;EACI,wBAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;AA3BJ","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n$lt-blue: #7DB7CC;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$green: #C7CC68;\n$DCSD-logo-green: #84ae30;\n$dashboard-blue: #0d6efd;\n$dk-blue: #0A4064;\n$important: #FEBF31;\n$highlight: #FDF9D0;\n$grey0: #EDf0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$grey5: #333;\n$pale-blue: #C0DEF0;\n$pearl-dk-blue: #0762a7;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n$teal-logo: #46A8B0;\n\n$pale-blue-green: #9acdd2;\n$pale-blue-green-outline: #75c2c9;\n\n$pale-purple: #bca0d3;\n$pale-purple-outline: #946eb4;\n","@import \"../styles/global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n.requests-table {\n    table {\n        border-collapse: separate;\n        border-spacing: 0px;\n        width: 100%;\n\n        caption {\n            caption-side: top;\n            text-align: center;\n        }\n\n        thead>tr>th {\n            @include borderRadius(5px 5px 0 0);\n            background-color: $pale-blue;\n            border-color: $grey2;\n            border-style: solid;\n            border-width: 1px;\n            color: $dk-blue;\n            font-size: 0.85rem;\n            font-weight: 500;\n            padding: 5px;\n            text-align: center;\n        }\n\n        thead>tr>th.icon-header {\n            font-size: 1.65rem;\n        }\n\n        thead>tr>th.subheader {\n            border-radius: revert;\n            border: none;\n            font-size: 0.75rem;\n        }\n\n        thead>tr>th.left {\n            border-left: 1px solid $grey2;\n        }\n\n        thead>tr>th.right {\n            border-right: 1px solid $grey2;\n        }\n\n        tbody>tr {\n            border-left: 1px solid $grey2;\n            border-right: 1px solid $grey2;\n        }\n\n        tbody>tr.stripe {\n            background-color: $grey0;\n            ;\n        }\n\n        tbody>tr.out-of-district {\n            background-color: $highlight;\n        }\n\n        tbody>tr.hidden-row {\n            display: none;\n        }\n\n        tbody>tr>td {\n            border-right: 1px solid $grey1; //pale-blue;\n            border-bottom: 1px solid $grey1; // $pale-blue;\n            font-size: 0.78rem;\n            padding: 3px;\n        }\n\n        tbody>tr>td>button {\n            display: flex;\n            flex-direction: row;\n            justify-content: space-between;\n\n            span {\n                font-size: 0.9rem;\n                font-weight: 500;\n            }\n        }\n\n        tbody>tr>td.email {\n            max-width: 10%;\n            width: 180px;\n            word-wrap: anywhere;\n        }\n\n        tbody>tr>td.icons {\n            align-items: right;\n            background-color: white;\n            border: none;\n            border-bottom: 1px solid $grey1;\n            border-left: 1px solid $grey1;\n        }\n\n        tbody>tr>td.icons-with-note {\n            align-items: right;\n            background-color: white;\n            border: none;\n            border-bottom: none;\n            border-left: 1px solid $grey1;\n        }\n\n        tbody>tr>td.oe-out {\n            background-color: white;\n        }\n\n        td.center {\n            text-align: center;\n        }\n\n        tbody>tr>td>div>textarea {\n            @include borderRadius(5px);\n            width: 100%;\n        }\n\n        tbody>tr>td>div>button {\n            margin-top: 5px;\n        }\n\n        tbody>tr>td.first {\n            border-left: 1px solid $grey2;\n        }\n\n        tbody>tr>td.last {\n            border-right: 1px solid $grey2;\n        }\n\n        tbody>tr>td.notes {\n            background: $pale-blue;\n            font-size: 0.9rem;\n            padding: 10px;\n        }\n\n        tbody>tr>td.icon-last {\n            border: none;\n            border-left: 1px solid $grey1;\n            border-bottom: 2px solid $grey2;\n        }\n\n        tbody>tr>td>div.flexed-td {\n            align-items: center;\n            display: flex;\n            font-size: 0.7rem;\n            justify-content: flex-start;\n        }\n\n        tbody>tr>td>div.preferred-language {\n            @include borderRadius(3px);\n            background-color: $important;\n            color: black;\n            font-weight: 420;\n            padding: 0 3px 0 3px\n        }\n\n        tfoot>tr {\n            background-color: white;\n        }\n\n        tfoot>tr>td {\n            border-top: 1px solid $grey2;\n            padding-top: 10px;\n        }\n\n        tfoot>tr>td.icons {\n            border-top: 1px solid $grey2;\n            padding-top: 10px;\n        }\n\n        tfoot>tr>td>div {\n            display: flex;\n            flex-direction: row;\n            justify-content: center;\n            width: 100%;\n            margin: 0 auto;\n        }\n\n        tfoot>tr>td>div>.showing-records {\n            font-size: 0.8rem;\n            font-style: italic;\n            margin-top: 5px;\n            width: 33%;\n        }\n\n        .small {\n            font-size: 0.7rem;\n            font-weight: 500;\n            margin-left: 5px;\n            margin-right: 5px;\n        }\n\n        .fixed-btn {\n            display: block;\n            margin: 2px 0 2px 0;\n            min-width: 120px;\n            white-space: nowrap;\n        }\n    }\n}\n\ntable#legend-table {\n    border-collapse: separate;\n    border-spacing: 0px;\n    width: 100%;\n    margin: 10px 0 10px 0;\n    width: 100%;\n\n    thead>tr>th {\n        @include borderRadius(5px 5px 0 0);\n        border: 1px solid $grey1;\n        color: $dk-blue;\n        font-size: 1.65rem;\n        font-weight: 500;\n        padding: 10px;\n    }\n\n    tbody>tr>td {\n        border-right: 1px solid $grey1;\n        border-top: 1px solid $grey1;\n        padding: 5px;\n    }\n\n    tbody>tr>td.first {\n        border-left: 1px solid $grey1;\n        text-align: center;\n        margin: 0 auto;\n        vertical-align: top;\n\n        span.sibling-icon {\n            font-size: 1.4rem;\n        }\n    }\n\n    tbody>tr>td.last {\n        border-bottom: 1px solid $grey1;\n    }\n\n    tbody>tr>td.highlight {\n        font-size: 0.7rem;\n        vertical-align: middle;\n    }\n\n    tbody>tr.out-of-district {\n        background-color: $highlight;\n    }\n}\n\ntable#enroll-table {\n    tbody>tr>td {\n        font-size: 0.9rem;\n    }\n}\n\n.enroll-p {\n    font-size: 0.9rem;\n}\n\n.danger-p {\n    @include borderRadius(5px);\n    background-color: $highlight;\n    border: 2px solid $red;\n    color: black;\n    padding: 5px;\n}\n\n.success-p {\n    color: green;\n    font-weight: 500;\n}\n\np.out-of-district {\n    background-color: $highlight;\n}\n\n.iep {\n    @include borderRadius(5px);\n    background-color: $pearl-blue;\n    border: 1px solid $pearl-blue;\n    color: $white;\n    font-size: 0.7rem;\n    font-weight: bold;\n    padding: 4px;\n}\n\n.sibling {\n    font-size: 1.0rem;\n    padding: 4px;\n}\n\nform#request-form,\nform#enroll-form {\n    div.enroll-flex {\n        margin-top: 5px;\n        width: 100%;\n    }\n\n    div.input-row {\n        display: flex;\n        flex-direction: row;\n        justify-content: space-between;\n        margin-bottom: 3px;\n    }\n\n    input,\n    label,\n    select,\n    textarea {\n        @include borderRadius(3px);\n        display: block;\n        width: 50% !important;\n    }\n\n    input,\n    select {\n        @include standardInput();\n        min-width: 180px !important;\n    }\n\n    label {\n        color: $grey5;\n        font-size: 0.9rem;\n        font-weight: 500;\n    }\n\n    textarea {\n        @include standardInput();\n        width: 100% !important;\n    }\n\n    .checkbox input:before {\n        content: '';\n        background: #fff;\n        display: block;\n        width: 10px;\n        height: 10px;\n        border: 1px solid black;\n    }\n\n    .checkbox input:checked:before {\n        background-color: green;\n    }\n}\n\ndiv.REQUEST {\n    background-color: grey;\n    height: 30px;\n    margin-right: 5px;\n    width: 10px;\n}\n\ndiv.CANCELLED_REQUEST,\ndiv.DENY_OFFER,\ndiv.DENY_REQUEST {\n    background-color: red;\n    height: 30px;\n    margin-right: 5px;\n    width: 10px;\n}\n\ndiv.MAKE_OFFER_PENDING,\ndiv.WAIT_LIST {\n    background-color: orange;\n    height: 30px;\n    margin-right: 5px;\n    width: 10px;\n}\n\ndiv.MAKE_OFFER {\n    background-color: blue;\n    height: 30px;\n    margin-right: 5px;\n    width: 10px;\n}\n\ndiv.ACCEPT_OFFER {\n    background-color: #28bfcd;\n    height: 30px;\n    margin-right: 5px;\n    width: 10px;\n}\n\ndiv.ENROLLED {\n    background-color: green;\n    height: 30px;\n    margin-right: 5px;\n    width: 10px;\n}\n\ndiv.NO_RESPONSE {\n    background-color: purple;\n    height: 30px;\n    margin-right: 5px;\n    width: 10px;\n}","@import \"./Colors.scss\";\n\n@mixin borderRadius($radius: 5px) {\n    border-radius: $radius;\n}\n\n@mixin dialogueBold() {\n    font-weight: 600;\n    font-size: .9em;\n}\n\n@mixin input() {\n    border-radius: 5px;\n    font-weight: 400;\n    width: 100%;\n}\n\n@mixin infoRounded($radius) {\n    background: $information;\n    border-bottom-left-radius: $radius;\n    border-bottom-right-radius: $radius;\n}\n\n@mixin shadow() {\n    box-shadow: 0.1rem 0.15rem 0.3rem 0 $shadow;\n}\n@mixin shadowBottom() {\n    box-shadow: 0 0.1rem 0.15rem 0 $shadow;\n}\n@mixin standardInputContainer() {\n    font-weight: 500;\n    font-size: .9rem;\n    margin: 10px 0;\n}\n@mixin standardInput() {\n    @include borderRadius(5px);\n    border: none;\n    border: 1px solid $grey3;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
